import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { umsCategorySelection } from './components/category-selection/category-selection.component'
import { umsContainerSelection } from './components/container-selection/container-selection.component'
import { umsDateSelection } from './components/date-selection/date-selection.component'
import { umsOrderCard } from './components/order-card/ums-order-card.component'
import { umsServiceSelection } from './components/service-selection/service-selection.component'
import { umsTasksiteSelection } from './components/tasksite-selection/tasksite-selection.component'
import { trackingConfig } from './components/tracking/tracking.component'
import { containerStockConfig } from './containers/container-stock/container-stock.component'
import { orderCreateConfig } from './containers/order-create/order-create.component'
import { orderSearchConfig } from './containers/order-search/order-search.component'
import { tasksiteOrdersComponent } from './containers/orders/orders.component'
import { umsValidateOrderDate } from './directives/ums-validate-order-date.directive'
import { tasksiteOrdersState } from './orders.states'

const orderModule = {
  components: {
    umsCategorySelection,
    tasksiteOrdersComponent,
    umsTasksiteSelection,
    umsContainerSelection,
    umsServiceSelection,
    umsDateSelection,
    umsOrderCard,
  },
  configBlocks: [orderCreateConfig, trackingConfig, orderSearchConfig, containerStockConfig],
  directives: { umsValidateOrderDate },
  states: [tasksiteOrdersState],
}

loadNg1Module(ngmodule, orderModule)



// WEBPACK FOOTER //
// ./app/orders/orders.module.js